import(/* webpackMode: "eager" */ "/opt/trendrain/trendrain-web/src/app/mypage/page.tsx");
